module.exports = __webpack_public_path__ + "static/media/pencil.b70b5ad7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Flow/images/pencil.svg
// module id = 4057
// module chunks = 0